// Consent-gated Google Analytics 4 loader.
// GA4 only loads AFTER the visitor accepts cookies AND a Measurement ID is set
// via REACT_APP_GA4_ID in frontend/.env (e.g. G-XXXXXXXXXX).
let loaded = false;
const GA4_ID = process.env.REACT_APP_GA4_ID;

export function loadGA4() {
  if (loaded || !GA4_ID) return;
  loaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA4_ID);
}
